<template lang="html">
  <div v-bind="attrWithTextColor">
    <div class="v-input__control">
      <div class="v-input__slot">
        <div class="v-test-field__slot">
          <v-label
            v-if="label"
            :absolute="true"
            :value="true"
            :focused="hasError"
            :dark="dark"
            :color="validationState"
            :disabled="disabled"
          >
            {{ label }}
          </v-label>
          <div class="ft-check-chips mt-1">
            <check-chip
              v-for="(dayValue, i) in normalizedDayValues"
              :key="'check-chip_' + i"
              :value="dayValue"
              :error-messages="getPathErrors(jsonPath, getDayKey(i))"
              :error="!!internalErrorMessages[0]"
              :outlined="true"
              :class="'mr-1'"
              @change="(v) => setDay(v, i)"
            >
              {{ daysShort[i] }}
            </check-chip>
          </div>
        </div>
      </div>
      <v-messages
        :value="allErrorMessages"
        :color="validationState"
        :role="hasMessages ? 'alert' : null"
      />
    </div>
  </div>
</template>

<script>
import {daysProper, daysLower, daysShort} from '../util/values'
import validatable from 'vuetify/lib/mixins/validatable'
import BindsAttrs from 'vuetify/lib/mixins/binds-attrs'
import colorable from 'vuetify/lib/mixins/colorable'

export default {
  name: 'DaysSwitch',
  mixins: [BindsAttrs, validatable, colorable],
  props: {
    getPathErrors: {
      type: [Function],
      default (path) {
        return []
      }
    },
    clearPathErrors: {
      type: [Function],
      default (path) {
      }
    },
    jsonPath: {
      type: String,
      default: '$[0]'
    },
    label: {
      type: String,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: undefined
    },
    dayPrefix: {
      type: String,
      default: undefined
    },
    value: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      isDirty: false
    }
  },
  computed: {
    computedId () {
      return this.id || `input-${this._uid}`
    },
    attrWithTextColor () {
      return this.setTextColor(this.validationState, {
        class: this.classes
      })
    },
    classes () {
      return {
        'v-input': true,
        'v-text-field': true,
        'v-text-field--is-booted': true,
        'ft-days-switch': true,
        'v-input--has-state': this.hasState,
        'v-input--hide-details': this.hideDetails,
        'v-input--is-label-active': true,
        'v-input--is-dirty': this.isDirty,
        'v-input--is-disabled': this.disabled,
        'v-input--is-focused': this.isFocused,
        'v-input--is-loading': this.loading !== false && this.loading !== undefined,
        'v-input--is-readonly': this.readonly,
        // 'error--text': this.hasError,
        // 'v-input--dense': this.dense,
        ...this.themeClasses,
      }
    },
    noneSelected () {
      return this.required && !this.normalizedDayValues.find(v => v)
    },
    hasError () {
      return this.internalErrorMessages.length > 0 || this.apiErrorMessages.length > 0
    },
    normalizedDayValues () {
      return daysShort.map((ds, i) => this.value[this.getDayKey(i)])
    },
    daysShort () {
      return daysShort
    },
    shouldValidate () {
      console.warn('Should Validate?')
      return this.required
    },
    apiErrorMessages () {
      const errors = []
      for (let i = 0; i < 7; i += 1) {
        var fieldError = this.getPathErrors(this.jsonPath, this.getDayKey(i))
        if (fieldError && fieldError.length) {
          for (let i2 in fieldError) {
            // Deduplicate
            if (fieldError[i2] && typeof fieldError[i2] === 'string' && errors.indexOf(fieldError[i2]) < 0) {
              errors.push(fieldError[i2])
            }
          }
        }
      }
      return errors
    },
    allErrorMessages () {
      return this.apiErrorMessages.concat(this.internalErrorMessages)
    },
    internalErrorMessages () {
      const errors = []
      if (this.isDirty && this.noneSelected) errors.push('At least one day must be selected')
      return errors
    }
  },
  methods: {
    validate (force, val) {
      if (force) this.isDirty = true
      const result = !force || !this.required || !this.internalErrorMessages.length
      console.warn('Validate?', force, val, this.value, result)
      return result
    },
    getDayKey (dayIndex) {
      return this.dayPrefix ? this.dayPrefix + daysProper[dayIndex] : daysLower[dayIndex]
    },
    setDay (val, dayIndex) {
      this.isDirty = true
      this.$set(this.value, this.getDayKey(dayIndex), val)
      this.$emit('input', this.value)
      const errorMessage = this.getPathErrors(this.jsonPath, this.getDayKey(dayIndex))
      if (errorMessage && errorMessage._clear) {
        errorMessage._clear()
      }
    },
    clearDaySelectorErrors () {
      for (let i = 0; i < 7; i += 1) {
        const errorMessage = this.getPathErrors(this.jsonPath, this.getDayKey(i))
        if (errorMessage && errorMessage._clear) {
          errorMessage._clear()
        }
      }
    }
  }
}
</script>
<style>
.ft-days-switch.v-text-field > .v-input__control > .v-input__slot:before {
  border-width: 0 !important;
}
</style>
